import { defineNuxtPlugin } from '#app'
import VConsole from 'vconsole'

export default defineNuxtPlugin((nuxtApp) => {
  if (process.env.NODE_ENV === 'development' && process.client) {
    // const vConsole = new VConsole()
    
    // return {
    //   provide: {
    //     vconsole: vConsole
    //   }
    // }
  }
});